import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './admin-layout.component';
import { GiantSharedModule } from './shared/GiantSharedModule';
import { GiantSidebarModule } from './sidebar/sidebar.module';
import { ContentModule } from './components/content/content.module';
import { ToolbarModule } from './components/toolbar/toolbar.module';
import { NavbarModule } from './components/navbar/navbar.module';
import { FooterModule } from './components/footer/footer.module';


@NgModule({
    declarations: [
        AdminLayoutComponent
    ],
    imports     : [
        RouterModule,

        GiantSharedModule,
        GiantSidebarModule,

        ContentModule,
        FooterModule,
        RouterModule,
        NavbarModule,
        ToolbarModule
    ],
    exports     : [
        AdminLayoutComponent
    ]
})
export class AdminLayoutModule
{
}
